import React, { ReactNode } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import links from "links";
import LogoLink from "./LogoLink";
import clsx from "clsx";
import stadiaLogo from "assets/images/logos/licensing/logo_stadia.png";
import steamLogo from "assets/images/logos/licensing/logo_steam.png";
import xboxOneLogo from "assets/images/logos/licensing/logo_xboxone.png";
import xboxSeriesXSLogo from "assets/images/logos/licensing/logo_xboxseriesxs.png";
import playstationLogo from "assets/images/logos/licensing/logo_playstation.png";
import amdLogo from "assets/images/logos/licensing/logo_amd.png";
import nvidiaLogo from "assets/images/logos/licensing/logo_nvidia.png";
import VwLogo from "assets/svgs/logos/VwLogo";
import Spacer from "components/Spacer";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        platformLogoContainer: {
            flex: "1 1 auto",
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            [theme.breakpoints.down("sm")]: {
                flexDirection: "column",
                alignItems: "center",
            },
        },
        platformLicenseLogoContainer: {
            display: "flex",
            width: "100%",
            justifyContent: "center",
            [theme.breakpoints.down("sm")]: {
                flexDirection: "column",
                alignItems: "center",
                marginBottom: "20px",
            },
        },
        amdLogo: {
            maxWidth: "125px !important",
        },
        nvidiaLogo: {
            maxWidth: "125px !important",
        },
        vwLogo: {
            width: "initial !important",
        },
        item: {
            maxWidth: 200,
            flex: "1 1 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& img": {
                width: "100%",
                height: "unset",
            },
        },
        vwItem: {
            maxWidth: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& img": {
                width: "100%",
                height: "unset",
            },
        },
        platformItem: {
            margin: "0px 3%",
            [theme.breakpoints.down("sm")]: {
                margin: 0,
            },
        },
        firstItem: { marginLeft: 0 },
        lastItem: { marginRight: 0 },
    })
);

interface ILogoLink {
    logo: ReactNode;
    link: string;
    className?: string;
}

export default function GamePlatformLogos() {
    const classes = useStyles();

    const logoLinks: ILogoLink[] = [
        {
            logo: <img src={xboxSeriesXSLogo} alt="Xbox Series X Logo" />,
            link: links.licensing.xbox,
        },
        {
            logo: <img src={xboxOneLogo} alt="Xbox One Logo" />,
            link: links.licensing.xbox,
        },
        {
            logo: <img src={playstationLogo} alt="Playstation Logo" />,
            link: links.licensing.playstation,
        },
        {
            logo: <img src={steamLogo} alt="Steam Logo" />,
            link: links.licensing.steam,
        },
        {
            logo: <img src={stadiaLogo} alt="Stadia Logo" />,
            link: links.licensing.stadia,
        },
    ];

    return (
        <div className={classes.root}>
            <div className={classes.platformLicenseLogoContainer}>
                <LogoLink
                    logoLink={{
                        logo: <img src={amdLogo} alt="Amd Logo" />,
                        link: links.licensing.amd,
                    }}
                    className={clsx(classes.item, classes.platformItem, classes.amdLogo)}
                />
                <Spacer size={2} />
                <LogoLink
                    logoLink={{
                        logo: <img src={nvidiaLogo} alt="nvidia Logo" />,
                        link: links.licensing.nvidia,
                    }}
                    className={clsx(classes.item, classes.platformItem, classes.nvidiaLogo)}
                />
                <Spacer size={2} />
                <LogoLink
                    logoLink={{
                        logo: <VwLogo style={{ color: "white", fontSize: 40 }} />,
                        link: links.licensing.vw,
                    }}
                    className={clsx(classes.vwItem, classes.platformItem, classes.vwLogo)}
                />
            </div>

            <Spacer size={2} />

            <div className={classes.platformLogoContainer}>
                {logoLinks.map((logoLink: ILogoLink, i) => {
                    const firstItem = i === 0;
                    const lastItem = i === logoLinks.length - 1;

                    return (
                        <div
                            key={i}
                            className={clsx(
                                classes.item,
                                classes.platformItem,
                                firstItem ? classes.firstItem : "",
                                lastItem ? classes.lastItem : ""
                            )}
                        >
                            <LogoLink logoLink={logoLink} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
